import ProtectedRoute from "components/ProtectedRoute";
import RequireRoleRoute from "components/RequireRoleRoute";
import Role from "constants/roles";
import { Route, createRoutesFromElements } from "react-router-dom";
import DatasetViewer from "views/DatasetViewer";
import DatasetDetail from "views/DatasetViewer/DatasetDetail/DatasetDetail";
import LidarClearance from "views/LidarClearance";
import Login from "views/Login";
import ObjectTypeMerge from "views/ObjectTypeMerge";
import Splash from "views/Splash";

const routes = createRoutesFromElements(
  <>
    <Route path="/login" element={<Login />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/" element={<Splash />} />
      <Route path="/datasets" element={<DatasetViewer />} />
      <Route
        path="/datasets/defect/:datasetId"
        element={<DatasetDetail kind="defect" />}
      >
        <Route path=":imageId" />
      </Route>
      <Route path="/datasets/:datasetId" element={<DatasetDetail />}>
        <Route path=":imageId" />
      </Route>
      <Route element={<RequireRoleRoute role={Role.GlobalAdmin} />}>
        <Route path="/admin/object-type-merge" element={<ObjectTypeMerge />} />
      </Route>
      <Route element={<RequireRoleRoute role={Role.SkyqraftEmployee} />}>
        <Route path="/admin/lidar-clearance" element={<LidarClearance />} />
      </Route>
    </Route>
  </>
);

export default routes;
